export default __webpack_public_path__ + "static/media/discordNew.dc9d15b7.svg";